import React from 'react';
import { Link } from 'react-router-dom';
import SectionHeader from '@/components/site/SectionHeader';
import GoldText from '@/components/site/GoldText';
import PrinciplesList from '@/components/site/PrinciplesList';

const AboutPreview = () => (
  <section aria-labelledby="about-preview-title" className="border-t border-rule">
    <div className="section-container grid gap-12 lg:grid-cols-2 lg:gap-16">
      <div>
        <SectionHeader
          id="about-preview-title"
          eyebrow="09 / Who you work with"
          title={
            <>
              A partner for the decisions—<GoldText>and the implementation.</GoldText>
            </>
          }
        >
          <p>
            GoldCrusade brings business diagnosis and hands-on implementation into the same engagement. The work begins
            with a practical question: what should this assistant accomplish for your business?
          </p>
        </SectionHeader>
        <Link to="/about" className="text-link mt-8 inline-block">
          About GoldCrusade →
        </Link>
      </div>
      <PrinciplesList />
    </div>
  </section>
);

export default AboutPreview;
